<template>
  <div>
    <div>
      <div>
        <div v-if="showpopup" :class="chatAlignmentPosition()">
          <div
            :class="{
              'chat-child spacing-for-beside-buttons': showCallusTextus === -1,
              'text-white': showCallusTextus === 3,
            }"
          >
            <div
              class="theme-bg-color rounded-corners btn-websites button-primary"
              style="border: 1px solid"
              :class="{
                'nada-text-us-btn _theme_font_bold font-weight-bold': showCallusTextus === -1,
                'bgcolor-primary': !textUsButtonColor,
              }"
              :style="[showCallusTextus === 3 ? applyStyles : {}, chatAlignment]"
              @click.prevent="openchatwidget()"
            >
              <template v-if="textUsCTAButtonLabel && !ismobile">
                {{ textUsCTAButtonLabel }}
              </template>

              <template v-else-if="textUsMobileCTAButtonLabel && ismobile">
                <div class="d-flex align-items-center">
                  <i class="primaryicon-contact-chat d-block"></i>
                  <span class="ml-2">{{ textUsMobileCTAButtonLabel }}</span>
                </div>
              </template>

              <template v-else>
                <div class="d-flex align-items-center">
                  <i class="primaryicon-contact-chat d-block"></i>
                  <span class="ml-2 text-capitalize">{{ buttonLabel }}</span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- note: do not remove spacing-for-beside-button class -->
      <div
        v-if="showwidget && !ismobile"
        class="textwidgetbox spacing-for-beside-buttons"
        :class="chatAlignmentPosition()"
      >
        <div>
          <div class="textwidget-close-icon" @click.prevent="hidewidget()">
            <em class="primaryicon-times" />
          </div>
          <div v-if="integrateWithText">
            <integrate-text-form />
          </div>
          <div v-else>
            <chat-form />
          </div>
        </div>
      </div>
      <div v-if="showwidget && ismobile">
        <textus-form
          :opentextus="true"
          @hidemodal="
            showpopup = true;
            showwidget = false;
          "
          :open-text-widget="true"
        />
      </div>
    </div>
  </div>
</template>
<script>
import chatForm from "../../Components/ChatWidget/TextusForm/TextusForm.vue";
import TextusModalForm from "../../components/Shared/TextUs/TextUs.vue";
import axios from "axios";
import { TagManagerContainer } from "../../Events/GoogleTagManager/TagManagerContainer";
import integrateTextForm from "../../Components/ChatWidget/IntegrateWithText/IntegrateWithText.vue";
import { fireSonicChatIconClick } from "../../Events/SonicDataLayer/sonicDataService";
import ShiftDigitalContainer from "../../Events/ShiftDigital/ShiftDigitalContainer";
import {
  fireMobileFooterLinkEvents,
  fireTagChatIconClick,
} from "../../Events/TagManagerServices/TaggingEventForPages";
export default {
  components: {
    "chat-form": chatForm,
    "textus-form": TextusModalForm,
    "integrate-text-form": integrateTextForm,
  },
  props: {
    showCallusTextus: {
      type: Number,
      default: -1,
      required: false,
    },
  },
  data() {
    return {
      textUsCTAButtonLabel: window.textUsCTAButtonLabel,
      textUsMobileCTAButtonLabel: window.textUsMobileCTAButtonLabel,
      showwidget: false,
      ismobile: false,
      openservice: false,
      opensales: false,
      showpopup: true,
      primarycolor: window.primaryColor,
      buttonColor: "",
      borderColor: "",
      textColor: "",
      integrateWithText: window.integrateWithText,
      buttonLabel: "Text us",
      textUsButtonColor: window.textUsButtonColor,
      textUsFontColor: window.textUsFontColor,
    };
  },
  computed: {
    applyStyles() {
      if (this.showCallusTextus !== 3) {
        return this.defaultStyles;
      } else {
        return this.applyCallUsTextUsStyles;
      }
    },
    applyCallUsTextUsStyles() {
      const color = `${
        this.textUsFontColor ? this.textUsFontColor : window.textUsMobileButtonFontColor
      } !important`;
      const backgroundColor = `${
        this.textUsButtonColor ? this.textUsButtonColor : window.textUsMobileButtonColor
      } !important`;
      const fontFamily = `${
        window.themeName.toLowerCase() === "volvo" ? "Volvo Novum-SemiLight, sans-serif" : ""
      } !important`;

      return {
        height: "60px",
        fontSize: "1.4rem !important",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: "5px",
        fontWeight: "inherit !important",
        color,
        backgroundColor,
        fontFamily,
        border: "transparent !important",
        borderRadius: `0px !important`,
      };
    },
    defaultStyles() {
      return {
        backgroundColor: this.textUsButtonColor,
        color: this.textUsFontColor,
        borderColor: this.borderColor,
      };
    },
    chatAlignment() {
      if (window.textWidgetPosition === "Bottom Right") {
        return {
          right: "10px",
          left: "auto",
        };
      } else if (window.textWidgetPosition === "Bottom Left") {
        return {
          left: "10px",
          right: "auto",
        };
      } else {
        return {
          left: "0",
          right: "0",
        };
      }
    },
  },
  mounted() {
    //Implement Sd IMplement
    requestAnimationFrame(() => {
      let shiftDigitalEvent = ShiftDigitalContainer.getShiftDigitalObject();
      if (shiftDigitalEvent && typeof shiftDigitalEvent.chatImpressionEvent === "function") {
        shiftDigitalEvent.chatImpressionEvent();
      }

      if (window.accountId === "32678") {
        this.buttonLabel = "Chat or Text us";
      }
      this.showwidget = false;
      this.showpopup = true;
      if (window.innerWidth < 500) {
        this.ismobile = true;
      }

      this.buttonColor = this.tvm_getParams("chatwidget.js")["btncolor"];
      this.borderColor = this.tvm_getParams("chatwidget.js")["bordercolor"];
      this.textColor = this.tvm_getParams("chatwidget.js")["color"];

      if (
        window.textWidgetPosition === "On Header" &&
        document.querySelector("#position_top") &&
        document.querySelector(".nada-text-us-btn") &&
        this.ismobile
      ) {
        document.querySelector(".nada-text-us-btn").style.display = "none";
      }
    });
  },
  methods: {
    tvm_getParams(script_name) {
      let v_scripts = document.getElementsByTagName("script");
      for (let item of v_scripts) {
        if (item.src.toLowerCase().indexOf(script_name) > -1) {
          let v_pa = item.src.split("?").pop().split("&");
          let v_p = {};
          for (let vItem of v_pa) {
            let kv = vItem.split("=");
            v_p[kv[0].toLowerCase()] = kv[1];
          }
          return v_p;
        }
      }
      return {};
    },
    chatAlignmentPosition() {
      let classes = !this.ismobile ? "" : "chat-con";
      classes =
        window.textWidgetPosition && window.textWidgetPosition.toLowerCase() === "bottom left"
          ? classes + " position-left-alignment"
          : classes + " position-right-alignment";
      if (this.showCallusTextus === 3) {
        classes = "";
      }
      return classes;
    },
    showTextwidget() {
      this.showwidget = true;
      this.showpopup = false;
    },
    hidewidget() {
      this.showwidget = false;
      this.showpopup = true;
      let shiftDigitalEvent = ShiftDigitalContainer.getShiftDigitalObject();
      if (shiftDigitalEvent && typeof shiftDigitalEvent.chatClosedsdEvent === "function") {
        shiftDigitalEvent.chatClosedsdEvent();
      }
    },
    nadaclose() {
      this.showpopup = false;
    },
    openchatwidget() {
      let buttonLabel = this.ismobile ? this.textUsMobileCTAButtonLabel : this.textUsCTAButtonLabel;

      fireSonicChatIconClick(buttonLabel);
      fireTagChatIconClick({
        comm_status: "start",
        department: "sales",
        product_name: "Apollo AssistantAI",
      });
      let tagManager = TagManagerContainer.getDealerObject();
      if (tagManager && typeof tagManager.clickToChatEvent === "function") {
        tagManager.clickToChatEvent();
      }
      this.showwidget = true;
      this.showpopup = false;
      if (!this.ismobile) {
        this.showwidget = true;
        this.showpopup = false;
      }
      let loc_userguid = typeof window.userguid === "undefined" ? "" : window.userguid;
      let loc_isBot = typeof window.IsBot === "undefined" ? false : window.IsBot;
      let eventname = 324;
      let userPin = window.userPin;
      let arrLogConsumerEvent = {
        PIN: userPin,
        SessionID: loc_userguid,
        IsCrawlerBot: loc_isBot,
        TextusType: "",
        TextusMessage: "",
      };
      fireMobileFooterLinkEvents(
        this.textUsMobileCTAButtonLabel ? this.textUsMobileCTAButtonLabel : this.buttonLabel
      );
      requestAnimationFrame(() => {
        this.saveconsumerdata(arrLogConsumerEvent, eventname);
        window.googleBingCustomEvent("Text App", "Open", "Start", 1, "text us chat plugin click");
        let shiftDigitalEvent = ShiftDigitalContainer.getShiftDigitalObject();
        if (shiftDigitalEvent && typeof shiftDigitalEvent.chatClickEvent === "function") {
          shiftDigitalEvent.chatClickEvent();
        }
      });
    },
    saveconsumerdata(params, name) {
      let paramsdata = params;
      let eventname = name;
      let url = window.location.origin + "/Service/Log/SaveCosnumerEvents?eventName=" + eventname;
      axios
        .post(url, paramsdata)
        .then((response) => {
          if (response.status === 200) {
            console.log("Event logged successfully..");
          }
        })
        .catch((error) => {
          console.log(error + ":" + "Something Went wrong. Please try again");
        });
    },
  },
};
</script>

<style>
.textwidget-close-icon {
  display: block !important;
  text-align: right;
  font-size: 24px;
  cursor: pointer;
}

.chat-image {
  position: absolute;
  width: 50px;
  top: -30px;
  right: 0px;
}

.nada-text-us-btn {
  cursor: pointer;
  text-transform: capitalize;
  font-size: 18px;
  color: #fff;
  text-align: center;
  padding: 12px 14px;
  letter-spacing: 2px;
  display: block;
  margin: 0px auto;
  min-width: 100px;
  background: #007cc3;
}

.nada-chat-con {
  padding: 18px;
  border-radius: 5px;
  border: 1px none #000000;
  box-shadow: 1px 1px 3px 2px rgba(2, 2, 2, 0.19);
  color: #555555;
  z-index: 999999999;
  width: 18%;
  position: fixed;
  bottom: 10px;
  right: 5px;
  min-width: 310px;
  box-sizing: border-box;
}

.nada-child {
  box-sizing: border-box;
  margin: 12px 0;
  font-size: 14px;
}

.nadaimg {
  max-width: 100%;
  height: auto;
  float: left;
  margin: 4px 10px 0px 0;
  display: block;
  position: relative;
}

.nada-close {
  position: absolute;
  right: 0;
  top: 0;
  padding: 8px;
  color: #ffffff;
  font-size: 14px;
  line-height: 14px;
  border: 1px none #ffffff;
  cursor: pointer;
  min-width: 1em;
  z-index: 9999999999;
  border-radius: 0px;
  box-shadow: 0px 0px 0px 0px rgba(2, 2, 2, 0.23);
  text-shadow: 0px 0px 0px rgba(0, 0, 0, 0.23);
}

.nada-bgcolor {
  background-color: rgba(0, 144, 178, 1);
}

.nada-color {
  color: rgb(0, 144, 178);
}

.nada-main-text {
  line-height: 19px;
}

.nada-learn-more {
  display: block;
  text-align: center;
  clear: both;
}

.learn-more-btn {
  color: #ffffff;
  margin: 0 auto;
  border-radius: 50px;
  cursor: pointer;
  padding: 12px 16px 10px;
  min-width: 70px;
  display: inline-block;
  font-size: 14px;
}

.chat-con {
  position: fixed;
  bottom: 40px;
  z-index: 1;
}

.position-right-alignment {
  right: 10px;
}

.position-left-alignment {
  left: 10px;
}

.chat-con .circle-chat-con {
  background: transparent;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  position: relative;
}

.chat-con .circle-chat-con img {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.textwidgetbox {
  position: fixed;
  bottom: 50px;
  width: 20%;
  background: #fff;
  padding: 20px;
  z-index: 999999999;
  border-radius: 5px;
  border: 1px none #000000;
  box-shadow: 1px 1px 3px 2px rgba(2, 2, 2, 0.19);
  background-color: rgba(254, 254, 254, 1);
}

.textwidgetbox .text-radio-con .text-radio-box .sales-radio-con .float-left {
  width: 48%;
}

.textwidgetbox .text-radio-con .text-radio-box .service-radio-con .float-left {
  width: 100%;
}

.cls-3 {
  fill: #fff;
}

@media (max-width: 1400px) {
  .textwidgetbox {
    width: 30%;
  }
}

@media (max-width: 800px) {
  .textwidgetbox {
    width: 70%;
  }

  .send-btn-con .text-send-btn {
    margin: 5px 0;
  }

  .textwidgetbox .note-info-text {
    font-size: 11px;
  }

  .text-radio-con {
    margin: 10px 0;
  }

  .textwidgetbox .text-radio-con .text-radio-box .radio-text {
    margin: 5px 0;
    font-size: 11px;
  }
}

@media (max-width: 600px) {
  .chat-con {
    bottom: 25px;
    z-index: 1100 !important;
  }

  .chat-con.position-right-alignment {
    right: 4px;
  }

  .chat-con.position-left-alignment {
    left: 4px;
  }

  .nada-text-us-btn {
    cursor: pointer;
    text-transform: capitalize;
    font-size: 15px;
    color: #fff;
    padding: 8px 14px;
    letter-spacing: 2px;
    display: block;
    z-index: 3;
    width: max-content;
    position: fixed;
    bottom: 80px;
    right: 0;
    left: 0;
    text-align: center;
    margin: 0 auto;
  }

  .nada-chat-con {
    width: 97%;
    min-width: unset;
    margin: 0 auto;
  }

  .textwidgetbox {
    width: 80%;
  }

  .chat-textarea-con {
    margin: 10px auto;
  }

  .textwidgetbox .text-radio-con .text-radio-box .sales-radio-con .float-left {
    width: 50%;
  }

  html[lang="es"] #fixed-footer-bottom .btn-websites,
  #fixed-footer-bottom .mctc-prefix font,
  #fixed-footer-bottom .primaryicon-phone,
  #fixed-footer-bottom .primaryicon-contact-chat {
    font-size: 14px !important;
  }
}

@media (min-width: 768px) and (max-width: 1366px) {
  .chat-con {
    bottom: 89px;
  }
}
</style>
